<div class="h-[60vh] w-[60vw]">
  @if (data | async; as target) {
    <app-modal-header>
      <div class="flex items-center">
        <div class="p-2">
          <p translate class="text-xl font-semibold text-theme-900">trilhas.relatorio.publico-alvo</p>
        </div>
      </div>
    </app-modal-header>
    <div app-modal-content class="h-full w-full overflow-y-auto p-0!">
      <div class="w-full rounded-xl bg-base-status-info-50 p-5 shadow-inner">
        <div #dataTemplate class="w-full">
          <div class="w-full overflow-x-auto">
            <table app-table class="w-full border-separate border-spacing-0.5 border-spacing-y-0.5">
              <thead class="text-center">
                <th
                  translate
                  class="w-3/6 whitespace-nowrap bg-theme-500! px-4 py-2 text-center text-base! uppercase text-theme-contrast first:rounded-l-lg last:rounded-r-lg [th]:bg-theme-500 [th]:text-theme-contrast [&:not(th)]:bg-white"
                >
                  trilhas.relatorio.grupo-usuario
                </th>
                <th
                  translate
                  class="w-3/6 whitespace-nowrap bg-theme-500! px-4 py-2 text-center text-base! uppercase text-theme-contrast first:rounded-l-lg last:rounded-r-lg [th]:bg-theme-500 [th]:text-theme-contrast [&:not(th)]:bg-white"
                >
                  trilhas.relatorio.entidade
                </th>
              </thead>
              <tbody>
                @for (group of target; track group.id) {
                  <tr class="group odd:bg-white! even:bg-theme-50!">
                    <td
                      class="item-center flex justify-center border-b border-b-theme-200 p-4! group-hover:bg-theme-200!"
                    >
                      <p
                        class="rounded px-5 text-center text-base text-theme-contrast"
                        [ngClass]="{ 'bg-theme-400': !group.usuario_id, 'bg-blue-400': group.usuario_id }"
                      >
                        {{ group.nome }}
                      </p>
                    </td>
                    <td class="border-b border-b-theme-200 px-5! py-4! text-center group-hover:bg-theme-200!">
                      {{ group.editora ?? group.divisao ?? group.uniao ?? group.campo ?? group.entidade }}
                    </td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  } @else {
    <app-skeleton></app-skeleton>
  }
</div>
